button:
  about: 关于
  back: 返回
  home: 首页
  reset: 重置
  search: 查询
  operation: 操作
  edit: 编辑
  save: 保存
  cancel: 取消
  confirm: 确定
not-found: 未找到页面
commodity-management: 商品管理
order-management: 订单管理
store: 店铺
storeInfo: 店铺列表
integrationSet: 同步设置
orde-sync-policy: 订单同步策略
postal-service-update-policy: CN 物流服务更新策略
vendor: 服务商
postal-service-required: 请填写所有带“*”的信息
atLeastOne : 至少请维护一条Linnworks物流服务
synchronization-platform-sku: 同步平台SKU
synchronization-platform-order: 同步订单
synchronization-platform-order-placeholder: 输入平台订单号
tracking-number-status: 中间件的履约情况
lw-order-status: LW的订单状态
select-lw-order-status: 请选择LW的订单状态
oc-outbound-order-status: OC出库单状态
select-oc-bound-order-status: 请选择OC出库单状态
platform-order-number: 平台订单号
ocOutboundOrderStatus:
  draft: 草稿
  submitted: 已提交
  accepted: 已接单
  cancelled: 已取消
  createPickingTask: 生成拣货任务
  picked: 已拣选
  exception: 订单异常
  packed: 已打包
  outbound: 已出库
  inDelivery: 派送中
  delivered: 派送完成
  undeliverableReturn: 无法送达被退回
  failed: 订单审核失败
  buyerReturn: 买家退回
trackingNumberStatusLabels:
  all: 全部
  waiting: 待下单
  already: 已下单
  failed: 下单失败
  canceled: 已取消
form-order-numbers-placeholder: 最多输入20个平台订单号，用回车键分割每行
form-sku-placeholder: 最多输入20个SKU，用回车键分割每行
statusLabels:
  all: 全部
  waiting: 待推送
  already: 已推送
  abnormal: 异常
  failed: 推送失败
syncStatusLabels:
  all: 全部
  success: 成功
  fail: 失败
  init: 未同步
  ing: 推送中
status: 状态
inventory-sync-status: 库存同步状态
batch-push-to-oc: 批量推送至OC
inventory-sync-strategy: 库存同步策略
batch-sync-inventory: 批量库存同步
authStatus: 授权状态：
authLabels:
  all: 全部
  active: 生效中
  inActive: 已失效
authTable:
  platform: 所属平台
  storeName: 店铺名称
  ocId: OCID
  authStatus: 授权状态
  authTime: 授权更新时间
bulkOrder: 批量下单
syncPolicy: 同步策略
orderList:
  orderId: 平台订单号
  paymentStatus: 平台订单付款状态
  logisticsStatus: 平台订单发货状态
  trackingNumberStatus: 下单状态
  buyerCountry: 目的国家
  orderSkuAndQuantity: 订单SKU*数量
  totalPrice: 订单金额
  payTime: 付款时间
  packageCode: OC出库单号
  packageStatus: OC出库单状态
  warehouseCore: 仓配中心
  logisticsProvider: 物流服务商
  thirdPartyNo: 物流服务
  trackingNumber: 物流追踪号
  salesTime: 下单时间
  cancelOrder: 取消下单
  orders: 下单
  shipmentStatus: 发货同步平台状态
editAddress:
  buyerAddress1: 收件人地址1
  buyerAddress2: 收件人地址2
  buyerCity: 城市
  buyerName: 收件人全名
  buyerCompany: 公司名
  buyerEmail: 邮箱
  buyerMobile: 电话号码
  buyerCountry: 国家/地区
  buyerState: 省/州
  houseNumber: 门牌号
  buyerPostalCode: 邮编
  orderNotes: 备注
paymentStatusValue:
  paymentStatus0: 待付款
  paymentStatus1: 已付款
  paymentStatus2: 部分付款
  paymentStatus3: 已退款
  paymentStatus4: 部分退款
  paymentStatus5: 付款作废
  paymentStatus6: 付款失败
  paymentStatus7: 已付款(待确认)
  paymentStatus8: 重新下单
logisticStatusValue:
  logisticStatus0: 核查中
  logisticStatus1: 待发货(未处理)
  logisticStatus2: 已发货(已处理)
  logisticStatus3: 部分发货
  logisticStatus4: 已签收
  logisticStatus5: 部分签收
  logisticStatus6: 取消
  logisticStatus7: 部分取消
addressDialog:
  title: 编辑收货地址
  buyerNamePlaceholder: 收件人姓名不能为空
  buyerAddress1Placeholder: 收货地址1不能为空
  buyerCountryCodePlaceholder: 请选择国家/地区
deliverySkuAndQuantity: 发货SKU*数量
shipmentStatusValue:
  shipmentStatus0: 待同步
  shipmentStatus1: 成功
  shipmentStatus2: 同步中
  shipmentStatus3: 失败
responseMessage:
  selectOrder: 请选择订单
  selectGoods: 请选择商品
  operateSuccess: 操作成功
  setSyncOrderSuccess: 正在处理，请耐心等候
  operateError: 操作失败，请重新尝试
  setOrderSuccess: 操作下单成功
  setOrderFailed: 操作下单失败
  enterOrderNo: 请输入订单号
  pushSuccess: 推送成功
  pushFailed: 推送失败
  changeInventoryOrInputValue: 请选择仓库或输入固定值
  exceptionSuccess: 异常处理成功
  saveSuccess: 保存成功
cancelOrder: 取消下单
orderNo: 订单号
cancelOrderDialog:
  content: 正在取消OC订单，请谨慎操作。
  title: 取消OC订单提示
  success: 取消订单成功
  error: 取消订单失败
commodityManagement:
  pushStatus: 推送状态
  syncStatus: 库存同步状态
  syncTime: 最近库存同步时间
  push: 推送
  syncInventory: 同步库存
  rePush: 重新推送
  exceptionHandle: 异常处理
  productTitle: 商品名称
  platformInventory: 平台库存
  ocInventory: OC 库存
  price: 价格
syncInventoryDialog:
  title: 库存同步策略
  platformInventory: 平台库存
  addRule: 添加规则
  deleteBtn: 删除
  deleteTip: 是否确定删除？
  prompting: 提示
  location: Location
  efWh: eF Warehouse
  required: 必填项
  reconfirm: 您尚未设置库存同步策略，无法同步OC库存
pushToOcDialog:
  title: SKU推送至OC提示
  content: 所选SKU将推送至OC，请确认后操作。
  confirmTxt: 确认推送
syncStockDialog:
  title: 同步库存提示
  content: 所选SKU库存将按照规则重新同步，请确认后操作。
  confirmTxt: 确认同步
exceptionDialog:
  title: 异常处理提示
  content: SKU无法再次推送给OC，如需修改Seller SKUID 需要线下联系橙联客服，修改前请处理完成旧版Seller SKUID的订单
  confirmTxt: 知道了
strategyDialog:
  placeholder: 请选择仓库或输入固定数值
  title: 库存同步策略
warningMes:
  maxSku: 最多只能输入20个SKU
  maxOrder: 最多只能输入20个订单号
  noSelect: 未选择任何数据
  positiveInteger: 固定值需为正整数
  needNum: 固定值需为数字
  enterSku: 请输入sku
  enterToken: 请输入Token
  isOrders: 所选订单已经下单, 请勿重复操作
syncSkuResponse:
  title: 同步库存成功
  content1: 同步SKU任务已经完成, 刷新页面可查看。
  content2: 同步总数：
  content3: 成功总数：
  content4: 失败总数：
  failed: 失败SKU为：
  allFailed: 同步SKU同步失败
syncOrdersResponse:
  title: 批量下单完成
  content1: 批量下单已经完成, 刷新页面可查看。
  content2: 同步总数：
  content3: 成功总数：
  content4: 失败总数：
  failed: 失败订单为：
  allFailed: 批量下单失败
error:
  systemError: 系统异常，请联系管理员。
order-source: 订单来源
order-source—all: 全部
order-source—others: 其他
platform-order-id: 平台订单ID
ebay-order-id: eBay订单ID
oc-order-id: OC订单ID
table-ebay-order-id: 'eBay订单:'
autofulfill-setting: 自动发货设置
platform-order-switch-tip: 平台订单的仓库和物流服务与OC匹配时，订单会自动推送OC出库。
ebay-order-switch-tip: eBay订单自动发货
other-order-switch-tip: 其它渠道订单自动发货
autofulfill-switch-tip: 自动发货
warehouse-mapping: 仓库匹配
warehouse-mapping-text: 平台订单的配送中心，匹配OC的仓配中心
oc-fulfillment-center: OC仓配中心
platform-distribution-center: 平台订单配送中心
shipping-mapping: 物流服务匹配
shipping-mapping-text: 平台物流服务，匹配OC的物流服务
oc-shipping-service: OC物流服务
platform-carrier: 平台物流服务
carrier-name: 物流公司名称-运输等级
add: 添加
autofulfill-cancel: 取消
autofulfill-save: 保存
autofulfill-open: 开启
autofulfill-close: 关闭
autofulfill-example: '示例：Example: UPS-Standard'
repeat-tip: 平台物流服务已匹配
authorize: 授权
reAuthorize: 重新授权
getToken: 授权获取Token
recycleBin: 订单回收站
deleteOrder: 删除订单
reduction: 还原订单
delContent: 确认要删除选中订单吗? 删除后可从【订单回收站】恢复该订单。
configTitle1: 订单标记：
configTitle2: '*勾选后，Linnworks上通过OC履约到订单将被自动添加该标记'
locationSetTitle: 处理订单仓配中心
locationSetTitleTips: 选择处理订单时使用的平台仓配中心
locationSetLabel: 仓配中心

